module.exports = __webpack_public_path__ + "61bd4ab1d57bbf31ac4f318254c24897.png";